import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType } from "DataTypes/Form";
import { VaccineForm } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { DataActionType } from ".";
import RedoxApi from "Service/Redox.api";
import { useDispatch } from "react-redux";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { CheckStringEmpty } from "Utils/common";
import DateTime from "Utils/DateTime";

interface AddEditViewModalProps {
  onClose: () => void;
  refreshList: () => void;
  dataAction: DataActionType
}

const UpdateVaccine: FC<AddEditViewModalProps> = (props) => {
  const dispatch = useDispatch();
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { dataAction, onClose, refreshList } = props;
  const isEdit = dataAction.action == "EDIT";
  const isView = dataAction.action == "VIEW";
  const isDelete = dataAction.action == "DELETE";
  const [formData, setFormData] =
    useState<FormObjType[]>(structuredClone(VaccineForm));

  useEffect(() => {
    handleLoadData();
  }, [dataAction.data?.id, dataAction.action]);

  const handleLoadData: () => void = () => {
    let newFormData = structuredClone(VaccineForm);
    const newData = JSON.parse(JSON.stringify(dataAction?.data));
    if (isEdit || isView || isDelete) {
      newFormData = newFormData.map(formEl => {
        let inputVal = CheckStringEmpty(newData[formEl.id]);
        if (formEl.boxType == "date") {
          inputVal = DateTime.ToLocalDate(inputVal);
        }
        return {
          ...formEl,
          inputVal,
          readOnly: isView || isDelete
        }
      })
    }
    setFormData(newFormData);
  };

  const handleSave: () => void = async () => {
    const { errorCheck, formData: newFormData } =
      CommonFormatter.HandleValidateForm(formData);
    setFormData(newFormData);
    if (!errorCheck) {
      dispatch(setFormLoader(true))
      const payload = {
        immunizations: [{
          id: dataAction.action == "EDIT" ? dataAction.data?.id : null,
          ...newFormData.reduce((newObj, el) => {
            let inputVal = el.inputVal;
            if (el.boxType == "date") {
              inputVal = DateTime.ToUTCDate(inputVal);
            }
            return {
              ...newObj,
              [el.id]: inputVal
            }
          }, {}),
          status: "Active",
        }],
        patientId: patientInfo.id,
      }
      const res = await RedoxApi.AddUpdateVaccine({ data: payload });
      if (res?.success) {
        !isEdit && setFormData(structuredClone(VaccineForm));
        dispatch(setAlertData(res?.alert));
        refreshList();
      }
      onClose();
      dispatch(setFormLoader(false))
    }
  };

  const handleDelete: () => void = async () => {
    dispatch(setFormLoader(true))
    const res = await RedoxApi.DeleteVaccine({ id1: dataAction.data?.id });
    if (res?.success) {
      dispatch(setAlertData(res?.alert));
      refreshList();
    }
    onClose();
    dispatch(setFormLoader(false))
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold" textTransform="capitalize">
          {dataAction.action?.toString().toLowerCase()} Vaccine
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid key={el.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                {FormObjSwitch({
                  formObj: el,
                  inputChange: async (props) => {
                    setFormData(
                      CommonFormatter.HandleInputChange2(props, formData)
                    );
                  },
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  }

                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {isDelete ?
            <Typography
              variant="body2"
              fontWeight="bold"
              letterSpacing="0.1rem"
            >
              <span style={{ color: "red" }}>Note: </span>
              This record will get
              permanently delete from the system. Are you sure?
            </Typography>
            :
            <Box></Box>
          }
          <Box
            display="flex"
            justifyContent="flex-end"
            sx={{ "&>button": { ml: 1 } }}
          >
            {isDelete && (
              <CstmBtn
                label={"Delete"}
                onClick={handleDelete}
                enableFormLoad={true}
              />
            )}
            {(!isView && !isDelete) && (
              <CstmBtn
                label={"Save"}
                onClick={handleSave}
                enableFormLoad={true}
              />
            )}
            <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default UpdateVaccine;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};
